import { type ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  carregando?: boolean;
}

export function Button({
  children,
  carregando = false,
  disabled,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      disabled={disabled || carregando}
      className={`rounded-md bg-primary px-4 py-2.5 text-sm font-semibold tracking-wide text-on-primary transition-colors hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
      {...props}
    >
      {carregando ? "Carregando..." : children}
    </button>
  );
}
